import $ from "jquery";

const elementBindings = (morningstarComponentId: string): any => {
  return {
    elementBindings: [
      {
        morningstarComponentId,
        container: document.getElementById(`${morningstarComponentId}-container`), // HTML element where tool will be loaded in
      },
    ],
  };
};

const configuration = (
  namespace: string,
  environment: string,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  appConfig: any
): any => {
  return {
    namespace,
    environment,
    overrides: appConfig,
  };
};

const cssConfig = {
  includeComponentCss: true,
  mds: {
    style: true,
    icons: true,
    version: "2.4.0",
  },
  // Add custom CSS path to override the Morningstar tool styling here - not necessary
  // customStyles: ["/Content/css/dist/morningstar.css"],
};

const getTokenConfig = (token: string): any => {
  return { apiGatewayToken: token };
};

const getFreshToken = (tokenApiUrl: string, loadScreener: (token: string) => void): void => {
  return $.getJSON(tokenApiUrl).done((data) => {
    document.cookie =
      "MSToken=" +
      data.access_token +
      ";expires=" +
      new Date(data.expiry_datetime).toUTCString() +
      ";secure=" +
      true +
      ";path='/'";
    loadScreener(data.access_token);
  });
};

const handleMorningStarError = (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error: any,
  tokenApiUrl: string,
  loadScreener: (token: string) => void
): void => {
  let retry = 0;
  window.console.log(error);
  if (retry < 1) {
    getFreshToken(tokenApiUrl, loadScreener);
    retry++;
  }
};

// We have an equivalent of this function in _quilter-functions.ts but keeping to MS-own one to stay consistent to their code
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const getQueryParam = (name: string, defValue: string, useHash?: any) => {
  const local = useHash ? location.hash : location.href.replace(location.hash, "");
  const reg = new RegExp("[&|?]" + name + "=([^&;]+?)(&|#|;|$)", "gi");
  const isHas = reg.test(local);
  return decodeURIComponent(isHas ? RegExp.$1 : defValue);
};

export default {
  configuration,
  cssConfig,
  elementBindings,
  getFreshToken,
  getTokenConfig,
  getQueryParam,
  handleMorningStarError,
};
